import { render, staticRenderFns } from "./HistoryBySession.vue?vue&type=template&id=06fb4ca7&scoped=true&"
import script from "./HistoryBySession.vue?vue&type=script&lang=js&"
export * from "./HistoryBySession.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBySession.vue?vue&type=style&index=0&id=06fb4ca7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb4ca7",
  null
  
)

export default component.exports